export const buildUrlWithQuery = (url: string, query: Record<string, unknown>) => {
  const parts: string[] = [];

  for (const [key, value] of Object.entries(query)) {
    if (value === undefined) {
      continue;
    }
    if (Array.isArray(value)) {
      if (value.length === 0) {
        continue;
      }
      for (const item of value) {
        parts.push(`${key}=${encodeURIComponent(String(item))}`);
      }
    } else {
      parts.push(`${key}=${encodeURIComponent(String(value))}`);
    }
  }

  return parts.length ? `${url}?${parts.join('&')}` : url;
};
